import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}


export const SanityKey = "skhKp10aYZGNBY0IOedy2Jml2daKqyX5tfhB0jlPPOILFjBJZ6fzYUluV8KKKCOMlFoygjeabhAzFHlObmqQ339dOYoNk67BusmpBIEqfc16ic5LEKjLnpjBhKPHgkXSkQ8vkmW0hCxjuAkFFxVtReq5wNP0BVeEJ6lDKabcobKyKKc0w9Mq"